import(/* webpackMode: "eager" */ "/vercel/path0/src/app/_providers/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css")